import PageModule from './PageModule';
import component from '../../containers/teaser/TeaserLayer';

/**
 * The module offers the possibility to display a modal layer with content on a page
 * @see https://confluence.db-n.com/x/KqP3
 */
class TeaserLayerModule extends PageModule {
  constructor(moduleData) {
    super(component, moduleData);
  }
}

export default TeaserLayerModule;
